import React from "react";

import { Divider } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";

import { FaLayerGroup } from "react-icons/fa";
import { BsDiamond, BsLayers, BsStarFill } from "react-icons/bs";

import RollupsItem from "./RollupsItem";
import SearchInput from "../SearchInput";

import { useStyles } from "./useStyles";

import { IRollupsItem, RollupsItemType, searchOptions } from "./helpers";
import { IRollups } from "modules/projects/types/entities";

interface IRollupsListProps {
  data?: IRollups;
  options: IRollupsItem[];
  value: IRollupsItem | null;
  disabledTypes?: RollupsItemType[];
  maxHeight?: number | string;
  onChange: (rollupId: string | "all", rollupsType: RollupsItemType) => void;
  onClose?: () => void;
}

export const typeIconsMap = {
  all: <BsStarFill size={16} />,
  collection: <FaLayerGroup size={16} />,
  group: <BsLayers size={16} />,
  project: <BsDiamond size={16} />
};

const RollupsList: React.FC<IRollupsListProps> = props => {
  const {
    data,
    options,
    value,
    maxHeight,
    onChange,
    onClose,
    disabledTypes = []
  } = props;

  const classes = useStyles({ maxHeight });

  return (
    <Autocomplete
      open
      disablePortal
      openOnFocus
      disableClearable
      onClose={onClose}
      value={value || undefined}
      renderTags={() => null}
      noOptionsText="No results found"
      options={options}
      ListboxProps={{ style: { padding: "0 0 5px 0" } }}
      getOptionLabel={option => option.label}
      getOptionSelected={(option, selectedValue) =>
        option?.value === selectedValue?.value
      }
      getOptionDisabled={option =>
        Boolean(option?.disabled) || disabledTypes.includes(option?.type)
      }
      filterOptions={(opts, state) => {
        if (data) {
          const filteredOptions = searchOptions({
            options,
            data,
            term: state.inputValue
          });
          return filteredOptions;
        }

        return opts;
      }}
      onChange={(_event, selection) => {
        onChange(selection?.value, selection?.type);
      }}
      classes={{
        paper: classes.paper,
        popperDisablePortal: classes.popperDisablePortal,
        option: classes.option,
        listbox: classes.listbox
      }}
      renderOption={(option, { selected }) => (
        <RollupsItem
          label={option.label}
          icon={typeIconsMap[option.type]}
          level={option.level}
          type={option.type}
          selected={selected}
          disabled={
            Boolean(option?.disabled) || disabledTypes.includes(option?.type)
          }
        />
      )}
      renderInput={params => {
        return (
          <>
            <SearchInput
              ref={params.InputProps.ref}
              inputProps={{ ...params.inputProps, value: undefined }}
              placeholder="Search collection, project or group"
              autoFocus
            />

            <Divider />
          </>
        );
      }}
    />
  );
};

export default React.memo(RollupsList);
